import { DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI } from '../../../types/default-cloud-graph-remote-link-entity-ati';
import { type ThirdPartyConfig } from '../../../types/schemas/types';
import { NounSubtypeKey, TypeFilterValueKey } from '../../../utils/filters/universalType';
import { get3PLogo } from '../../icons';
import { ProductResourceTypes3P } from '../types';
import { StripeIcon, StripeSearchResultIcon } from './icon';

export const stripeConfig: ThirdPartyConfig = {
	displayName: 'Stripe',
	id: 'stripe',
	resourceType: ProductResourceTypes3P.Stripe,
	icon: get3PLogo(StripeIcon, 'Stripe', 'medium'),
	searchResultIcon: get3PLogo(StripeSearchResultIcon, 'Stripe', 'large'),
	integrationAri: 'ari:cloud:platform::integration/stripe',
	typeFilterConfig: new Map([
		[
			TypeFilterValueKey.Invoice,
			{
				entities3P: DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI,
				subTypes3P: [NounSubtypeKey.Invoice],
			},
		],
	]),
	requiresOauth: true,
	isEnabled: () => true,
};
